import { getPersistenceData, setPersistenceData } from "./persistenceStorage";
import log2 from "./log2";
import * as _ from "lodash";

const log = log2("language");
export const LANGUAGES = [
    {
        name: "Turkish",
        code: "tr",
        order: 0,
    },
    {
        name: "English",
        code: "en",
        order: 1,
    },
    {
        name: "Russian",
        code: "ru",
        order: 2,
    },
];
export const fallbackLanguage = LANGUAGES[1];
export const getNavigatorLanguage = () => {
    log("getNavigatorLanguage");
    try {
        const lang = window.navigator.language;
        log("getNavigatorLanguage navigator", lang);
        return LANGUAGES.find((x) => lang.startsWith(x.code)) || fallbackLanguage;
    } catch (e) {
        log("getNavigatorLanguage fallbackLanguage");
        return fallbackLanguage;
    }
};
const LANG_STORAGE_KEY = "language";

export function getCurrentLanguage() {
    const language = getPersistenceData(LANG_STORAGE_KEY);
    log("getCurrentLanguage2", language);

    if (language) {
        try {
            const result = JSON.parse(language);
            if (_.isObject(result) && Object.keys(result).includes("code")) {
                log("getCurrentLanguage parsed", result);
                return result;
            } else {
                log("getCurrentLanguage parse error", result);
                return getNavigatorLanguage();
            }
        } catch (e) {
            log("getCurrentLanguage fallback to navigator lang");
            return getNavigatorLanguage();
        }
    }

    return getNavigatorLanguage();
}

export const getNavigatorTimezone = () => {
    try {
        const info = Intl.DateTimeFormat().resolvedOptions();
        return info;
    } catch (e) {
        return {
            locale: getNavigatorLanguage().code,
            timeZone: "UTC",
        };
    }
};

export function setCurrentLanguage(language) {
    log("setCurrentLanguage", language);
    setPersistenceData(LANG_STORAGE_KEY, JSON.stringify(language));
}
